import { render, staticRenderFns } from "./ObjectMarkEdit.vue?vue&type=template&id=2586a4ae&scoped=true&"
import script from "./ObjectMarkEdit.vue?vue&type=script&lang=ts&"
export * from "./ObjectMarkEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ObjectMarkEdit.vue?vue&type=style&index=0&id=2586a4ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2586a4ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VRow,VSwitch,VTextField})
